/**
 * Client release controls for features that are implemented but not ready for
 * public discovery. Keep this separate from backend feature gates so a backend
 * deployment cannot expose unfinished web UI in an already-shipped client.
 */
export const WEB_RELEASE_FLAGS = {
  affiliateRewardsUiEnabled: false,
} as const;

// Local design trial. Production builds must explicitly opt in to expose the POC.
export const STUDIO_POC_ENABLED = process.env.NODE_ENV === 'development'
  || process.env.REACT_APP_STUDIO_POC === 'true';
